import { useMemo } from "react"

const r_num = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export const Captcha = ({ setOk, min = 1, max = 8 }) => {
  const x = useMemo(() => r_num(max, min), [min, max]),
    y = useMemo(() => r_num(max, min), [min, max])

  const verify = (val) => setOk(val ? parseInt(val) === x + y : null)

  return (
    <>
      <div className="flex-row d-flex justify-content-start align-items-center">
        {x}+{y} =
        <input
          type="text"
          className="form-control mx-2"
          placeholder={"?"}
          onChange={(e) => verify(e.target.value)}
          style={{ width: "3rem", textAlign: "center" }}
        ></input>
      </div>
    </>
  )
}
